module.exports = __webpack_public_path__ + "static/media/ease-of-experience-metric-full.12a82b29.svg";